export const getStyles = (theme: any) => ({
  styles: {
    wrapper: {
      display: "flex",
      flexDirection: "row",
      mt: "12px",
      color: "transparent",
      maxHeight:'116px',
     
    },
    CardMedia: {
      width: "82px",
      minWidth: "82px",
      height: "116px",
      borderRadius: "8px",
      mr: "16px",
    },
    error: {
      mb: "15px",
      mt:0,
      height: "44px",
      "& input::placeholder": {
        color: theme.palette.grey[0],
        fontSize: "14px",
      },
      "& input": {
        height: "44px",
      },
      "& .MuiInputBase-input": {
        padding: " 0px  0px  0px 20px",
        height: "44px",
      },
    },
  },
});
